import type {QRLinkInput} from '@Libraries/qr-code/qr-code.types';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export enum QRLinkFormVariant {
  WEB_ADDRESS = 'webAddress',
  PAYMENT_LINK = 'paymentLink',
  MULTIMEDIA = 'multimedia',
}

interface QRLinkFormStrings {
  labelKey: string;
  placeholderKey: string;
  /** Absent where the placeholder already carries everything the visitor needs, as it does for a bare web address. */
  helpKey?: string;
}

export const QR_LINK_FORM_STRINGS: Record<QRLinkFormVariant, QRLinkFormStrings> = {
  [QRLinkFormVariant.WEB_ADDRESS]: {
    labelKey: 'pmwjs_qr_generator_url_label',
    placeholderKey: 'pmwjs_qr_generator_url_placeholder',
  },
  [QRLinkFormVariant.PAYMENT_LINK]: {
    labelKey: 'pmwjs_qr_generator_payment_link_label',
    placeholderKey: 'pmwjs_qr_generator_payment_link_placeholder',
    helpKey: 'pmwjs_qr_generator_payment_link_help',
  },
  [QRLinkFormVariant.MULTIMEDIA]: {
    labelKey: 'pmwjs_qr_generator_multimedia_label',
    placeholderKey: 'pmwjs_qr_generator_multimedia_placeholder',
    helpKey: 'pmwjs_qr_generator_multimedia_help',
  },
};

export interface QRLinkFormProps extends QRFormProps<QRLinkInput> {
  variant: QRLinkFormVariant;
}
